/**
 * Internal dependencies
 */
import WMUWCPopin from "./popin";

/**
 * 
 */
class WMUWCPopinManager {

	/**
	 * 
	 * @type String
	 */
	defaultTemplateId = '';

	/**
	 * 
	 * @type Array
	 */
	popinList = [];

	/**
	 * 
	 */
	constructor( args = {} )
	{
		this.defaultTemplateId = args.defaultTemplateId;
	}

	/**
	 * 
	 * @return {String}
	 */
	generateUid()
	{
		return Date.now().toString(36) + Math.random().toString(36).substring(2);
	}

	/**
	 * 
	 * @param {String} id Popin ID. If no ID is specified a new popin is created with an automatically generated ID.
	 * @param {Object} args Popin setup args.
	 * @return {WMUWCPopin}
	 */
	get( id = null, args = {} )
	{
		let popin;

		if ( id )
		{
			popin = this.getById( id );
		}
		else
		{
			id = this.generateUid();
		}

		if ( ! popin )
		{
			if ( ! args.templateId )
			{
				args.templateId = this.defaultTemplateId;
			}

			popin = new WMUWCPopin( args );
			popin.id = id;
			this.popinList.push( popin );
		}

		return popin;
	}

	/**
	 * 
	 * @param {String} id Popin ID. In most cases use the get method instead of this one.
	 * @return {WMUWCPopin}
	 */
	getById( id )
	{
		return this.popinList.find( ( popin ) => popin.id === id );
	}

}

export default WMUWCPopinManager;